const prefix = '@cashback';

export const CashbacksActionType = {
  GetCashbacks: `${prefix}/GET_CASHBACKS`,
  GetCashbackAvailableBalance: `${prefix}/GET_CASHBACK_AVAILABLE_BALANCE`,
  UpdateBankAccountDetails: `${prefix}/UPDATE_BANK_ACCOUNT_DETAILS`,
};
